<template>
	<div id="novel_chapter">
		<div class="novel_chapter">
			<div class="novel_list">
				<div class="novel_list1 cursor_1" @click="toPage">
					<img src="@/assets/image/icon_right.png" alt="">
					{{ seriesInfo.title }}<span class="t-m-l-30">进度：{{ seriesInfo.writed || 0 }}/{{ seriesInfo.chapters
					}}章</span>
				</div>
				<div class="flex">
					<div class="add-btn t-p-r-25" @click="seriesDetail">
						<el-button size="medium" type="warning">分卷详情</el-button>
					</div>
					<div class="add-btn" @click="lookChapter">
						<el-button size="medium" type="warning">查看大纲</el-button>
					</div>
				</div>

			</div>
			<div class="novel_chapter1">
				<div class="novel_chapter1_1">
					<!-- 表格标题 -->
					<div class="flex">
						<div class="novel_chapter1_3" v-for="(item, i) in chapterTitle" :key="i"
							:class="'w-' + (i + 1)">
							{{ item }}
						</div>
					</div>
					<!-- 章节 -->
					<div class="novel_chapter1_2" v-for="(item, i) in chapterList" :key="i"
						@click.self="lookChapters(i, item)">
						<div class="w-1 chapter-item">{{ item.chapter }}</div>
						<div class="w-2 chapter-item u-line-1" :title="item.title">
							<span class="t-p-l-20">{{ item.title }}</span>
							<div class="recall-yjy" v-if="item.recall">
								<span>已记忆</span>
							</div>
						</div>
						<div class="w-3 chapter-item">{{ item.wordCount }}</div>
						<div class="w-4 chapter-item">{{ item.lastUpadate }}</div>
						<div class="w-5 chapter-item flex-row-center">
							<div :class="item.status == 0 ?
								'novel_chapter1_8 novel_chapter1_9' : item.status == 1 ? 'novel_chapter1_30' : 'novel_chapter1_8'"></div>
							{{ item.status == 0 ? '未创作' : item.status == 1 ? '创作中' : '已完成' }}
						</div>
						<div class="w-6 chapter-item flex-row t-p-l-10 t-p-r-10">
							<div v-if="item.status != 0" class="flex">
								<div class="chapter-item-btn cursor_1" @click="editchapter(i, 1)">编辑章纲</div>
								<div class="chapter-item-btn cursor_1 t-m-l-20" @click="copy(item.id)">复制正文</div>
							</div>
							<div v-if="item.status == 0 && item.current && isShowZG === 'true'" class="flex">
								<div class="chapter-item-btn cursor_1" @click="editchapter(i, 2)">手写正文</div>
								<div class="chapter-item-btn cursor_1 t-m-l-20" @click="editchapter(i, 3)">AI写正文</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <bottomPage v-show="total" :total="total" @currentNUm="currentNUm" ref="bottompage"></bottomPage> -->
		<!-- <outlineContinuous :novelId="novelInfo.id" ref="outlineContinuous" @getContinued="getContinued">
		</outlineContinuous> -->

	</div>
</template>

<script>
import { copy } from '@/utils/utils'
import bottomPage from '@/components/bottom_page.vue' //底部分页
import outlineContinuous from '@/components/outline_continuous.vue'
import api from '@/api/api';
import lNApi from '@/api/longNovel';
import { EncryptionUtil } from '@/utils/encrypt'
export default {
	components: {
		bottomPage, outlineContinuous
	},
	data() {
		return {
			chapterTitle: ['章节', '章节名称', '字数', '发布时间', '状态', '操作'],
			chapterList: [],
			total: null, //总条数,
			pageNum: 1,
			newNumber: null, //最新章节
			seriesInfo: {}, // 小说分卷信息
			novelInfo: {}, // 小说信息
			isInit: false,//默认false 是初始化，true，不是初始化
			isShowZG: false
		}
	},
	created() {

	},
	methods: {
		toPage() {
			this.$router.go(-1)
		},
		//复制
		copy(chapterId) {
			lNApi.longChapterDetail({ chapterId }).then(async (res) => {
				if (res.code == 200) {
					let tc = res.data.title + '\n' + this.stripHtmlTags(res.data.content)
					const success = await copy(tc);
					if (success) {
						this.$message.success('复制成功');
					} else {
						this.$message.error('复制失败');
					}
				}
			})
		},
		async getChapterList(data) {
			let { pageNum, seriesInfo, isShowZG, novelInfo } = data
			console.log('data=', data)
			this.seriesInfo = seriesInfo;
			this.isShowZG = isShowZG
			this.novelInfo = novelInfo
			this.pageNum = pageNum
			try {
				if (this.$refs.bottompage) {
					this.$refs.bottompage.page(pageNum ? pageNum : this.pageNum)
				}
				await this.getNewChapter(this.novelInfo.id);
				const res = await lNApi.longChapterList({ seriesId: seriesInfo.id, pageNum: pageNum || this.pageNum });
				if (res.code === 200) {
					// this.total = res.total;
					let firstStatus = false;
					this.chapterList = res.data.map(item => {
						if (this.newNumber == item.chapter && !firstStatus) {
							firstStatus = true;
							return { ...item, current: true };
						}
						return { ...item, current: false };
					});
					// this.isInit = this.chapterList.some(item => item.statusInstructions === '已完成'|| item.statusInstructions == '创作中')
				}
			} catch (error) {
				console.error('获取章节列表出错:', error);
			}
		},
		async getNewChapter(id) {
			try {
				const res = await lNApi.currChapter({ id });
				if (res.code === 200) {
					if (!res.data || res.data == null) {
						this.newNumber = '章节都已完成';
					} else {
						this.newNumber = res.data.chapter;
					}
				}
			} catch (error) {
				console.error('获取最新章节出错:', error);
			}
		},
		currentNUm(pageNum) {
			this.pageNum = pageNum
			// this.getChapterList(this.novelInfo)
		},
		//当前分卷详情
		seriesDetail() {
			let editItem = JSON.parse(sessionStorage.getItem('editItem'))
			let item = {
				editType: 3,
				seriesInfo: this.seriesInfo,
				isLook: true
			}
			sessionStorage.setItem('editItem', JSON.stringify(item));
			this.$router.push({ path: '/seriesEditor' })
		},
		//查看大纲（章纲）
		lookChapter() {
			let editItem = JSON.parse(sessionStorage.getItem('editItem'))
			console.log('editItem=', editItem)
			let item = {
				id: this.novelInfo.id,
				novelInfo: this.novelInfo,
				editType: 3,
				seriesId: this.seriesInfo.id,
				series: this.seriesInfo,
				seriesNum: this.seriesInfo.seriesNum,
				isLook: true
			}
			sessionStorage.setItem('editItem', JSON.stringify(item));
			this.$router.push({ path: '/chapterOutline' })
		},
		//编辑
		lookChapters(i, item) {
			if (item.status != 0) {
				this.editchapter(i, 1)
			}
		},
		// 编辑 1编辑 2手写 3Ai生成
		editchapter(i, edit) {

			let editItem = {
				id: this.novelInfo.id,
				novelInfo: this.novelInfo,
				editText: edit,
				seriesId: this.seriesInfo.id,
				series: this.seriesInfo,
				seriesNum: this.seriesInfo.seriesNum,
				chapterId: this.chapterList[i].id,
				chapter: this.chapterList[i].chapter,
				chapterName: this.chapterList[i].title,
				// textId: this.chapterList[i].textId,
				pageNum: this.pageNum,
				pageSize: 10,
				asc: 'asc'
			};
			sessionStorage.setItem('editItem', JSON.stringify(editItem));
			this.$router.push({ path: '/seriesChapterEditor' });
		},
	}
}
</script>

<style lang="scss" scoped>
#novel_chapter {
	width: 100%;
	height: 100%;
	display: flex;
	flex-flow: column;
	justify-content: space-between;
}

.novel_list {
	height: 77px;
	justify-content: space-between;
	border-bottom: 1px solid #e6ebf0;
	padding: 0 25px;
	flex-shrink: 0;
	display: flex;
	align-items: center;
}

.novel_list1 {
	font-weight: 700;
	font-size: 19px;
	color: #111;
	display: flex;
	align-items: center;

	img {
		width: 23px;
		height: 23px;
		margin-right: 5px;
	}
}

.novel_chapter {
	background-color: #FFFFFF;
	// height: calc(100% - 90px);
	height: 100%;
	box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
	border-radius: 8px;
	overflow: hidden;
}

.novel_chapter1 {
	height: calc(100% - 78px);
	overflow-y: auto;
	-ms-overflow-style: none;
	scrollbar-width: none;
	padding: 25px;
}

.novel_chapter1_1 {
	height: 100%;

}

.novel_chapter1_2 {
	display: flex;

	.w-2,
	.w-6 {
		text-align: left !important;
	}
}

.chapter-item {
	font-size: 15px;
	color: #333333;
	height: 50px;
	line-height: 50px;
	border-bottom: 1px solid #E6EBF0;
	position: relative;
}

.chapter-item-btn {
	color: #548AFF;
}

.novel_chapter1_3 {
	font-size: 15px;
	color: #333333;
	height: 50px;
	line-height: 50px;
	background-color: #F5F7FA;
	border-right: 1px solid #E6EBF0;
	border-bottom: 1px solid #E6EBF0;
}

.novel_chapter1_8 {
	width: 10px;
	height: 10px;
	background: #01CC7A;
	border-radius: 50%;
	margin-right: 5px;
}

.novel_chapter1_30 {
	width: 10px;
	height: 10px;
	background: #548AFF;
	border-radius: 50%;
	margin-right: 5px;
}

.novel_chapter1_9 {
	background: #FFB400;
}

.w-1 {
	width: 5%;
	text-align: center;
}

.w-2 {
	width: 38%;
	padding-left: 10px;
	text-align: center;
}

.w-3 {
	width: 10%;
	text-align: center;
}

.w-4 {
	width: 20%;
	text-align: center;
}

.w-5 {
	width: 10%;
	text-align: center;
}

.w-6 {
	flex: 1;
	border-right: none;
	text-align: center;
}

.recall-yjy {
	position: absolute;
	left: 0;
	top: -8px;
	transform: rotate(-20deg);

	span {
		padding: 0 3px;
		color: #f56c6c;
		background-color: rgba(254, 240, 240, 0.2);
		border-radius: 6px;
		border: 1px solid #fde2e2;
		font-size: 14px;
		line-height: 1;
	}
}
</style>